import React, { useEffect, useState } from "react";
import * as MatStyled from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import moment from "moment/moment";
// import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
// import { getLocale } from "react-i18nify";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
// import Pagination from "@mui/material/Pagination";
import styled from "styled-components";
// import { useNavigate } from "react-router-dom";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  deleteAllSelectedReview,
  getAllReviewByAdmin,
  updateStatusAllApproveReview,
  updateStatusReview,
} from "src/api/review";
import { getLocale } from "react-i18nify";
import AddIcon from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import Rating from "@mui/material/Rating";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ModalConfirm from "../ui/ModalConfirm";
import ModalReviewDetail from "./ModalReviewDetail";
import ModalCreateReview from "./ModalCreateReview";
import { Alert } from "@mui/material";
import Switch from "@mui/material/Switch";
import { useAuth } from "src/hooks/useAuth";
const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;
const ImageReviewMore = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #f2f1f3;
  border-radius: 8px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;

  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;
const WrapperButtonHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  width: 200px;
  margin-left: auto;

  .Button-Add {
    color: #ffffff;
    width: 100%;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
  .Button-Add:disabled {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
  }
  .Button-Reply {
    background: #f3f1f2;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    padding: 8px 16px;
    color: #6c6c70;
  }
  .Button-Reply:focus {
    background: #f3f1f2;
  }
  .Button-Reply:hover {
    background: #f3f1f2;
    opacity: 0.9;
  }

  .Button-Approve {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    padding: 8px 16px;
    color: #e13b30;
  }
  .Button-Approve:focus {
    background: #e13b30;
    color: #fff;
  }
  .Button-Approve:hover {
    color: #fff;
    background: #e13b30;
    opacity: 0.9;
  }
  .Button-Del {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 17.5px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    color: #e13b30;
    padding: 0;
    min-width: 35px;
  }
`;
const WrapperButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0px;
  width: 150px;

  .Button-Add {
    color: #ffffff;
    width: 100%;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-Add:focus {
    background-color: #e04132;
  }
  .Button-Add:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
  .Button-Reply {
    background: #f3f1f2;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    padding: 8px 16px;
    color: #6c6c70;
  }
  .Button-Reply:focus {
    background: #f3f1f2;
  }
  .Button-Reply:hover {
    background: #f3f1f2;
    opacity: 0.9;
  }

  .Button-Approve {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 16px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    padding: 8px 16px;
    color: #e13b30;
  }
  .Button-Approve:focus {
    background: #e13b30;
    color: #fff;
  }
  .Button-Approve:hover {
    color: #fff;
    background: #e13b30;
    opacity: 0.9;
  }
  .Button-Del {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 17.5px;
    height: 34px;
    font-weight: 400;
    font-size: 12px;
    color: #e13b30;
    padding: 0;
    min-width: 35px;
  }
`;
const WrapperAlert = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  @keyframes showAlert {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;
const WarpperRating = styled.div`
  & > span > span > span {
    font-size: 1.5rem;
  }
`;

const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 55%;
  position: relative;
  display: flex;
  justify-content: center;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;
const WrapperStatus = styled.div`
  width: 28%;
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 8px;
  margin-top: 8px;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;
const ImgDisplay = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  object-position: center;
  border-radius: 16px;
`;

const ReviewImg = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  margin-right: 8px;
`;
const ImageNoData = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.div`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;
const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function ReviewList({ open }) {
  const { user, checkAllowPermission } = useAuth();
  // const navigate = useNavigate();

  const [dataReview, setDataReview] = useState([]);
  const [isVisibleConfirm, setIsVisibleConfirm] = useState(false);
  const [isVisibleReviewDetail, setIsVisibleReviewDetail] = useState(false);
  const [isVisibleCreateReview, setIsVisibleCreateReview] = useState(false);
  const [isVisibleConfirmApprove, setIsVisibleConfirmApprove] = useState(false);
  const [isVisibleConfirmHidden, setIsVisibleConfirmHidden] = useState(false);
  const [idApprove, setIdApprove] = useState(null);
  const [idHidden, setIdHidden] = useState({ id: null, status: null });
  const [idDetail, setIdDetail] = useState(null);
  const [isVisibleAlert, setIsVisibleAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    filter: "all",
  });
  const [rowCount, setRowCount] = useState(0);

  // function CustomPagination() {
  //   const apiRef = useGridApiContext();
  //   const page = useGridSelector(apiRef, gridPageSelector);
  //   const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  //   return (
  //     <WrapperPagination>
  //       <Pagination
  //         color="primary"
  //         count={pageCount}
  //         page={page + 1}
  //         onChange={(event, value) => apiRef.current.setPage(value - 1)}
  //       />
  //     </WrapperPagination>
  //   );
  // }
  const IOSSwitch = MatStyled.styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
      onChange={(e) => {
        setIdHidden({ id: props.id, status: props.checked });
        setIsVisibleConfirmHidden(true);
      }}
    />
  ))((props) => ({
    width: 56,
    height: 32,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "#219653",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },

      "& .MuiSwitch-thumb": {
        content: "''",
        position: "absolute",
        left: props.checked ? "10px" : "1px",
        top: props.checked ? "2px" : "2px",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // backgroundImage: props.checked
        //   ? `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Hide.svg')`
        //   : `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/Eye.svg')`,
        "&:before": {
          content: "''",
          position: "absolute",
          width: "100%",
          height: "100%",
          left: props.checked ? "-26px" : "26px",
          top: 0,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundImage: props.checked
            ? `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/manage_eye_1.svg')`
            : `url('https://xsurface-images.s3.ap-southeast-1.amazonaws.com/manage_eye_2.svg')`,
          // backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          //   "#fff"
          // )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
        },
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 24,
      height: 24,
    },
    "& .MuiSwitch-track": {
      borderRadius: 56 / 2,
      backgroundColor: "#D9D9D9",
      opacity: 1,
    },
  }));

  const columns = [
    {
      field: "selected",
      headerName: getLocale() === "th" ? "" : "",
      flex: 0.25,
      editable: false,
      sortable: false,
      headerAlign: "center",
      align: "center",
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Checkbox
            defaultChecked={false}
            checked={params.row.select}
            onChange={(e) => {
              setDataReview(
                dataReview.map((data) => {
                  if (data._id === params.row._id) {
                    return { ...data, select: e.target.checked };
                  } else {
                    return { ...data };
                  }
                }),
              );
            }}
            sx={{
              color: "#e04132",
              "&.Mui-checked": {
                color: "#e04132",
              },
            }}
          />
        );
      },
    },
    {
      field: "_id",
      headerName: getLocale() === "th" ? "สินค้า" : "Product",
      flex: 1.125,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              // height: "100%",
              margin: "8px",
              padding: "8px",
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              alignItems: "left",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap",
            }}
          >
            {!!params?.row?.pcId?.group_image?.product_display_image ===
            false ? (
              <ImageEmpty>
                <InsertPhotoIcon
                  sx={{
                    color: "rgba(0, 0, 0, 0.54)",
                    cursor: "pointer",
                  }}
                />
              </ImageEmpty>
            ) : (
              <ImgDisplay
                src={
                  params?.row?.pcId?.group_image?.product_display_image
                    ? params?.row?.pcId?.group_image?.product_display_image.replace(
                        ".com",
                        ".com/300x300",
                      )
                    : ""
                }
                alt={params?.row?.pcId?.group_image?.product_display_image}
              />
            )}
            <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.875rem",
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              }}
            >
              {params.row?.pcId?.product?.item_name}
            </div>
            <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              }}
            >
              {params?.row?.pcId?.size?.quantity === "size"
                ? `${`W `}${params?.row?.pcId?.size?.width} ${
                    params?.row?.pcId?.size?.unit_width.unit_en
                  } x ${`H `}${params?.row?.pcId?.size?.height} ${
                    params?.row?.pcId?.size?.unit_height.unit_en
                  } x ${`D `}${params?.row?.pcId?.size?.thickness} ${
                    params?.row?.pcId?.size?.unit_thickness.unit_en
                  }`
                : `${params?.row?.pcId?.size?.capacity_size} ${params?.row?.pcId?.size?.unit_capacity?.unit_en}`}
            </div>
            <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              }}
            >
              {params?.row?.seller_id?.company_name}
            </div>
            <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                textWrap: "nowrap",
              }}
            >
              {params.row.name}
            </div>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: getLocale() === "th" ? "วันที่" : "Date",
      flex: 1,
      editable: false,
      sortable: true,

      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "review",
      headerName: getLocale() === "th" ? "รีวิว" : "Review",
      flex: 1.25,
      editable: false,
      sortable: false,

      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              margin: "8px",
              padding: "8px",
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "column",
              alignItems: "left",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textWrap: "nowrap",
            }}
          >
            <WarpperRating
              className="MuiDataGrid-cellContent"
              style={{
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Rating
                name="read-only"
                size="large"
                value={params.row.rating.total}
                readOnly
                precision={0.1}
                sx={{
                  color: "#E6B558",
                  "& > span > span > span": {
                    fontSize: "1.5rem",
                  },
                }}
              />
            </WarpperRating>
            <div
              className="rowitem"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "#E6B558",
              }}
            >
              {params.row.suggest_id?.comment_th}
              {/* {`คุณภาพสินค้าโอเค`} */}
            </div>
            {/* <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
             
              {`สินค้าดี มีคุณภาพ มีบริการ...`}
            </div> */}
            <div
              className="MuiDataGrid-cellContent"
              style={{
                marginTop: "4px",
                marginBottom: "8px",
                fontSize: "0.75rem",
                fontWeight: 400,
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "flex",
              }}
            >
              {params?.row?.group_image?.review_image1 && (
                <ReviewImg src={params?.row?.group_image?.review_image1} />
              )}
              {params?.row?.group_image?.review_image2 && (
                <ReviewImg src={params?.row?.group_image?.review_image2} />
              )}
              {params?.row?.group_image
                ? Object.keys(params?.row?.group_image).length > 2 && (
                    <ImageReviewMore>+2</ImageReviewMore>
                  )
                : null}
            </div>
          </Box>
        );
      },
    },
    {
      field: "reply",
      headerName: getLocale() === "th" ? "ตอบกลับ" : "Reply",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <WrapperButton>
            {params?.row?.reply?.reply_text === undefined ? (
              <Button className="Button-Approve">{`ยังไม่ได้ตอบกลับ`}</Button>
            ) : (
              <Button
                className="Button-Reply"
                disabled={true}
              >{`ตอบกลับแล้ว`}</Button>
            )}
          </WrapperButton>
        );
      },
    },
    {
      field: "status",
      headerName: getLocale() === "th" ? "สถานะ" : "Status",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <WrapperButton>
            {params?.row?.status === "approve" ? (
              <Button
                disabled
                className="Button-Approve"
              >{`อนุมัติแล้ว`}</Button>
            ) : (
              <Button
                className="Button-Approve"
                onClick={() => {
                  setIsVisibleConfirmApprove(true);
                  setIdApprove(params.row._id);
                }}
              >{`อนุมัติ`}</Button>
            )}
          </WrapperButton>
        );
      },
    },
    {
      field: "view",
      headerName: getLocale() === "th" ? "แสดง" : "View",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <WrapperButton>
            <FormControlLabel
              control={
                <IOSSwitch
                  sx={{ m: 1 }}
                  defaultChecked
                  id={params?.row?._id}
                  checked={
                    params?.row?.is_hidden === undefined ||
                    params?.row?.is_hidden === false
                      ? true
                      : false
                  }
                />
              }
            />
          </WrapperButton>
        );
      },
    },
    // {
    //   field: "actions",
    //   headerName: getLocale() === "th" ? "รายละเอียด" : "Detail",
    //   type: "actions",
    //   flex: 1,
    //   sortable: false,
    //   disableColumnMenu: true,
    //   renderCell: (params) => {
    //     return (
    //       <>
    //         <WrapperButton>
    //           <Button
    //             className="Button-Approve"
    //             onClick={() => {
    //               setIsVisibleConfirmApprove(true);
    //               setIdApprove(params.row._id);
    //             }}
    //           >{`อนุมัติ`}</Button>
    //         </WrapperButton>
    //         <WrapperButton>
    //           <Button
    //             className="Button-Del"
    //             onClick={() => {
    //               setIsVisibleConfirm(true);
    //               setIdDelete(params.row._id);
    //             }}
    //           >
    //             <DeleteOutlineRoundedIcon />
    //           </Button>
    //         </WrapperButton>
    //       </>
    //     );
    //   },
    // },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData />
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound />
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getAllReviewByAdmin({
          ...dataSearch,
        });
        setDataReview(data.rows.map((data) => ({ ...data, select: false })));
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
  };

  const onApproveAll = () => {
    if (dataReview.filter((fil) => fil.select === true).length === 0) return;
    setIsLoading(false);
    setIsVisibleConfirmApprove(false);

    updateStatusAllApproveReview({
      _id: dataReview
        .filter((fil) => fil.select === true)
        .map((data) => data._id)
        .join(","),
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getAllReviewByAdmin({
            ...dataSearch,
          });
          setDataReview(data.rows.map((data) => ({ ...data, select: false })));
          setRowCount(data.count);
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirm(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirm(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };

  const onDeleteAll = () => {
    if (
      dataReview.filter((fil) => fil.select === true && fil.is_fake === true)
        .length === 0
    )
      return;
    setIsLoading(false);
    setIsVisibleConfirmApprove(false);

    deleteAllSelectedReview({
      _id: dataReview
        .filter((fil) => fil.select === true)
        .map((data) => data._id)
        .join(","),
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getAllReviewByAdmin({
            ...dataSearch,
          });
          setDataReview(data.rows.map((data) => ({ ...data, select: false })));
          setRowCount(data.count);
          setTitleAlert("Delete Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirm(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirm(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };

  const onApprove = () => {
    if (idApprove === null) return;
    setIsLoading(false);
    setIsVisibleConfirmApprove(false);

    updateStatusReview({
      _id: idApprove,
      status: "approve",
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getAllReviewByAdmin({
            ...dataSearch,
          });
          setDataReview(data.rows.map((data) => ({ ...data, select: false })));
          setRowCount(data.count);
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirm(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirm(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };
  const onHidden = () => {
    if (idHidden === null) return;
    setIsLoading(false);
    setIsVisibleConfirmHidden(false);

    updateStatusReview({
      _id: idHidden.id,
      status: idHidden.status === true ? "hidden" : "approve",
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getAllReviewByAdmin({
            ...dataSearch,
          });
          setDataReview(data.rows.map((data) => ({ ...data, select: false })));
          setRowCount(data.count);
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirm(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirm(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch });
  };

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getAllReviewByAdmin(dataSearch);
        setDataReview(data.rows.map((data) => ({ ...data, select: false })));
        setRowCount(data.count);
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.filter]);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiName>
          <DivMuiInside>
            <WrapperText>
              <TextField
                id="search-input"
                placeholder={
                  getLocale() === "th"
                    ? `ค้นหาโดย ชื่อสินค้า / ชื่อร้านค้า`
                    : `search by product name / seller name`
                }
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-review"
                      sx={{ padding: 0 }}
                      disabled={isLoading}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{
                          color: "#e04132",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({
                    ...dataSearch,
                    keyword: e.target.value,
                  });
                }}
                onKeyUp={(e) =>
                  e.code === "Enter" && isLoading === false
                    ? onSearchButton()
                    : null
                }
              />
            </WrapperText>
            <WrapperStatus>
              <FormControl fullWidth>
                <InputLabel>Review</InputLabel>
                <Select
                  className="TextField-without-border-radius"
                  id="search-input"
                  label="Status"
                  onChange={(e) => {
                    setDataSearch({
                      ...dataSearch,
                      filter: e.target.value,
                    });
                  }}
                  value={dataSearch.filter}
                >
                  {/* TODO: idk about value */}
                  <MenuItem value={"all"}>
                    {getLocale() === "th" ? `ทั้งหมด` : `All`}
                  </MenuItem>
                  {/* <MenuItem value={"wp"}>
                    {getLocale() === "th" ? `รีวิวล่าสุด` : `รีวิวล่าสุด`}
                  </MenuItem> */}
                  <MenuItem value={5}>
                    {getLocale() === "th" ? `5 ดาว` : `5 ดาว`}
                    <Rating
                      readOnly
                      value={5}
                      sx={{
                        marginLeft: "8px",
                        "& > span > span": {
                          fontSize: "1.25rem",
                        },
                      }}
                    />
                  </MenuItem>
                  <MenuItem value={4}>
                    {getLocale() === "th" ? `4 ดาว` : `4 ดาว`}
                    <Rating
                      readOnly
                      value={4}
                      sx={{
                        marginLeft: "8px",
                        "& > span > span": {
                          fontSize: "1.25rem",
                        },
                      }}
                    />
                  </MenuItem>
                  <MenuItem value={3}>
                    {getLocale() === "th" ? `3 ดาว` : `3 ดาว`}
                    <Rating
                      readOnly
                      value={3}
                      sx={{
                        marginLeft: "8px",
                        "& > span > span": {
                          fontSize: "1.25rem",
                        },
                      }}
                    />
                  </MenuItem>
                  <MenuItem value={2}>
                    {getLocale() === "th" ? `2 ดาว` : `2 ดาว`}
                    <Rating
                      readOnly
                      value={2}
                      sx={{
                        marginLeft: "8px",
                        "& > span > span": {
                          fontSize: "1.25rem",
                        },
                      }}
                    />
                  </MenuItem>
                  <MenuItem value={1}>
                    {getLocale() === "th" ? `1 ดาว` : `1 ดาว`}
                    <Rating
                      readOnly
                      value={1}
                      sx={{
                        marginLeft: "8px",
                        "& > span > span": {
                          fontSize: "1.25rem",
                        },
                      }}
                    />
                  </MenuItem>
                  <MenuItem value={"not replied"}>
                    {getLocale() === "th"
                      ? `ยังไม่ได้ตอบกลับ`
                      : `ยังไม่ได้ตอบกลับ`}
                  </MenuItem>
                  <MenuItem value={"replied"}>
                    {getLocale() === "th" ? `ตอบกลับแล้ว` : `ตอบกลับแล้ว`}
                  </MenuItem>
                  <MenuItem value={"fake"}>
                    {getLocale() === "th" ? `รีวิวที่สร้าง` : `รีวิวที่สร้าง`}
                  </MenuItem>
                </Select>
              </FormControl>
            </WrapperStatus>

            <WrapperButtonHeader>
              <Button
                className="Button-Add"
                startIcon={<AddIcon />}
                disabled={!checkAllowPermission("reviews.can_create")}
                onClick={() => setIsVisibleCreateReview(true)}
              >
                Create Review
              </Button>
            </WrapperButtonHeader>
          </DivMuiInside>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              margin: "16px 0",
              alignItems: "center",
            }}
          >
            <FormGroup style={{ marginLeft: "8px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={false}
                    sx={{
                      color: "#e04132",
                      "&.Mui-checked": {
                        color: "#e04132",
                      },
                      "& .MuiSvgIcon-root": {
                        borderRadius: 2,
                      },
                    }}
                    onChange={(e) => {
                      setDataReview(
                        dataReview.map((data) => ({
                          ...data,
                          select: e.target.checked,
                        })),
                      );
                    }}
                  />
                }
                label="Select all"
              />
            </FormGroup>
            <WrapperButtonHeader>
              {dataSearch.filter === "fake" ? (
                <Button
                  disabled={
                    dataReview.filter((data) => data.select === true).length > 0
                      ? false
                      : true
                  }
                  className="Button-Add"
                  // startIcon={<AddIcon />}
                  onClick={() => setIsVisibleConfirm(true)}
                >
                  ลบรีวิวที่สร้าง
                </Button>
              ) : (
                <Button
                  disabled={
                    dataReview.filter((data) => data.select === true).length > 0
                      ? false
                      : true
                  }
                  className="Button-Add"
                  // startIcon={<AddIcon />}
                  onClick={() => onApproveAll()}
                >
                  อนุมัติทั้งหมด
                </Button>
              )}
            </WrapperButtonHeader>
          </div>

          <WrapperDataGrid>
            <DataGrid
              rows={dataReview}
              getRowId={(row) => row._id}
              onCellClick={(e) => {
                if (
                  !checkAllowPermission("reviews.can_edit") ||
                  e.field === "status" ||
                  e.field === "selected" ||
                  e.field === "view"
                ) {
                  return;
                } else {
                  if (e.row.is_fake === true) {
                    setIsVisibleCreateReview(true);
                    setIdDetail(e.id);
                  } else {
                    setIsVisibleReviewDetail(true);
                    setIdDetail(e.id);
                  }
                }
              }}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount}
              // paginationMode="server"
              // page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              components={{
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiName>
        {isVisibleConfirm ? (
          <ModalConfirm
            title={"คุณต้องการลบรีวิวสินค้านี้ใช่หรือไม่?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirm(value) : onDeleteAll()
            }
            icon={"delete"}
          />
        ) : null}
        {isVisibleConfirmApprove ? (
          <ModalConfirm
            title={"คุณต้องการอนุมัติรีวิวสินค้านี้ใช่หรือไม่?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirmApprove(value) : onApprove()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleConfirmHidden ? (
          <ModalConfirm
            title={
              idHidden.status === false || idHidden.status === null
                ? "แสดงรีวิวนี้ใช่หรือไม่?"
                : "ปิดกั้นการมองเห็นรีวิวนี้ใช่หรือไม่?"
            }
            callBack={(value) =>
              value === false ? setIsVisibleConfirmHidden(value) : onHidden()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleReviewDetail ? (
          <ModalReviewDetail
            close={(disp, success) => {
              setIsVisibleReviewDetail(disp);
              setIdDetail(null);
              if (success) {
                setIsLoading(true);
                (async () => {
                  const { data } = await getAllReviewByAdmin({
                    ...dataSearch,
                  });
                  setDataReview(
                    data.rows.map((data) => ({ ...data, select: false })),
                  );
                  setRowCount(data.count);
                  setIsLoading(false);
                })();
              }
            }}
            id={idDetail}
          />
        ) : null}
        {isVisibleCreateReview && (
          <ModalCreateReview
            id={idDetail}
            close={(disp, success) => {
              setIsVisibleCreateReview(disp);
              setIdDetail(null);
              if (success) {
                setIsLoading(true);
                (async () => {
                  const { data } = await getAllReviewByAdmin({
                    ...dataSearch,
                  });
                  setDataReview(
                    data.rows.map((data) => ({ ...data, select: false })),
                  );
                  setRowCount(data.count);
                  setIsLoading(false);
                })();
              }
            }}
          />
        )}
        {isVisibleAlert && (
          <WrapperAlert>
            <DivAlert>
              <Alert
                className="MuiPaper-root-MuiAlert-root"
                severity={typeAlert}
              >
                {titleAlert}
              </Alert>
            </DivAlert>
          </WrapperAlert>
        )}
      </Main>
    </>
  );
}

export default ReviewList;
